import { MenuItem, MenuItemCommandEvent } from 'primeng/api';
import { IconType } from '@shared/utils/icons';

type QueryParams = Record<string, string | number | boolean | string[] | number[] | boolean[]>;

export class NavbarMenuItem implements MenuItem {
  label?: string;
  icon?: IconType;
  iconClass?: string | undefined;
  routerLink?: string;
  command?: (event?: MenuItemCommandEvent) => void;
  items?: NavbarMenuItem[];
  visible?: boolean = true;
  queryParams?: QueryParams;
  routerLinkActiveOptions?: { exact: boolean };

  constructor(init?: Partial<NavbarMenuItem>) {
    Object.assign(this, init);
  }
}

export class NavbarHeaderMenuItem {
  constructor(public text: string, public link?: string, public callback?: () => void) {}
}
